import { useState, useEffect } from 'react';
import axios from 'axios';

const Fetch = ({ endpoint = '', children }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const sanitizeContent = (content) => {
    if (!content) return content;
    return content.replace(/<img[^>]+src="([^">]+)"/g, (match, src) => {
      const filename = src.split('/').pop();
      return `<img src="https://d1vkr02c9udppg.cloudfront.net/${filename}"`;
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Add filter parameter to only fetch published items
        const response = await axios.get(
          `${process.env.REACT_APP_API_ENDPOINT}/${endpoint}`,
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_DIRECTUS_API_TOKEN}`,
            },
            params: {
              filter: { status: { _eq: 'published' } }
            }
          }
        );

        const processedData = response.data.data.map(article => {
          const firstImageMatch = article.article_content?.match(/<img[^>]+src="([^">]+)"/);
          const filename = firstImageMatch?.[1]?.split('/').pop();
          
          return {
            ...article,
            original_slug: article.slug,
            article_content: sanitizeContent(article.article_content),
            image_thumb: article.video?.id 
              ? `https://img.youtube.com/vi/${article.video.id}/0.jpg`
              : filename 
                ? `https://d1vkr02c9udppg.cloudfront.net/${filename}`
                : null
          };
        });

        setData(processedData);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [endpoint]);

  return children({ data, loading, error });
};

export default Fetch;